module.exports = __webpack_public_path__ + "img/image-006.4e514e00.png";